import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class StructureService {
  private baseUrl = environment.beServiceUrl;

  constructor(private http: HttpClient) {}

  getStructureTypes() {
    return this.http.get<any>(this.baseUrl + '/v1/facility/types');
  }

  getStructuresFromType(typeId: string) {
    return this.http.get<any>(
      this.baseUrl + '/v1/facility/find?typeCode=' + typeId
    );
  }

  setStructureForTransition(transitionUuid: string, facilityCode: string) {
    return this.http.put<any>(
      this.baseUrl +
        `/v1/transition/${transitionUuid}/facility/${facilityCode}/facility-change`,
      null
    );
  }

  deleteStructureForTransition(transitionUuid: string) {
    return this.http.put<any>(
      this.baseUrl +
        `/v1/transition/${transitionUuid}/facility-remove`,
      null
    );
  }

  getWardInfo(code: string) {
    return this.http.get<any>(
      this.baseUrl + `/v1/ward/${code}`
    );
  }
}
